module.exports = __webpack_public_path__ + "img/dompetkilat.9754e269.png";